// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4s-2";
export var blackBorderOnHover = "_4s-7";
export var cell = "_4s-6";
export var cellContainer = "_4s-3";
export var checked = "_4s-8";
export var disabled = "_4s-5";
export var featuredIconCellContainer = "_4s-9";
export var featuredIconTextContainer = "_4s-b";
export var featuredIconWrapper = "_4s-a";
export var noBorder = "_4s-c";
export var orangeSelectedRow = "_co-3";
export var overflowableText = "_4s-0";
export var overflowableTextContainer = "_4s-1";
export var row = "_4t-0";
export var rowCheckboxCell = "_4s-4";
export var selectableTable = "_co-2";